export enum FailedSignUpCases {
  'Invalid company' = 'sign up 1/2',
  'User already exists' = 'sign up 2/2',
  'Auth0 error' = 'auth0',
  'Unknown' = 'Unknown',
  'Email wasn\'t verified' = 'Verification email',
};
